export default "__VITE_ASSET__01ede8ce__"